export default "__VITE_ASSET__Dx1wlZP9__"